// Stages of the UG generation data prep custom workflows (planner extended and MU_POWER).
export const dataPrepStageConfig: Record<string, { label: string }> = {
  clean: { label: "Cleaning data" },
  ug_network: { label: "Generating underground network" },
  leadins: { label: "Generating leadins" },
  outputs: { label: "Preparing outputs" },
};
